import { OrdersRoutingModule } from './orders-routing.module';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';

import { OrdersComponent } from './orders.component';
import { OrderItemsComponent } from './order-items/order-items.component';

@NgModule({
  declarations: [OrdersComponent, OrderItemsComponent],
  imports: [
    SharedModule,
    OrdersRoutingModule
  ]
})
export class OrdersModule{}
